import {
  QUERY_INIT,
  CONFIG_INIT,
  GAME_CONFIG_LOADED,
} from "./../actions/actionIdentifiers";

export interface SharedState {
  queryLoaded: boolean;
  grade: number;
  unit: number;
  game?: number;
  webUrl: string;
  gameConfigLoaded: boolean;
}

const initialState: SharedState = {
  queryLoaded: false,
  grade: null,
  unit: null,
  game: null,
  webUrl: null,
  gameConfigLoaded: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case QUERY_INIT:
      return {
        ...state,
        queryLoaded: true,
        grade: payload.grade,
        unit: payload.unit,
        game: payload.game,
      };
    case CONFIG_INIT:
      return {
        ...state,
        webUrl: payload.webUrl,
      };
    case GAME_CONFIG_LOADED:
      return { ...state, gameConfigLoaded: true };
    default:
      return state;
  }
};
